import { Component, Input, OnDestroy } from '@angular/core';
import { IGridTableCellDispatcher, IGridTableHeaderModel } from '@types-custom/models/ui/grid-table-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IRendererModel } from '@types-custom/models/ui/renderer.model';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'sit-list-card-audit',
  templateUrl: './list-card-audit.component.html',
  styleUrls: ['./list-card-audit.component.scss'],
})
export class ListCardAuditComponent {
  @Input() headers: IGridTableHeaderModel[] = [];
  @Input() dataSource: Observable<any> | undefined;

  icon = Icon;

  dataCellType = {
    isNumber: (data: any) => typeof data === 'number',
  };


  handleCardAction(item: any, index: number) {
    const action = this.headers.find(h => h.dispatcher);
    if(action){
      const data ={
         row: item,
         index
      }
      action.dispatcher.next(data)
    }
  }

  handleClick(
    dispatcher: Subject<IGridTableCellDispatcher> | undefined,
    row: any,
    key: string | undefined,
    index: number
  ): void {
    if (dispatcher) {
      const data = {
        row,
        index,
        key,
      };

      dispatcher.next(data);
    }
  }

  resolveRenderData(
    toRender: IRendererModel,
    cellData: any,
    key: string,
    index: number,
    row: any
  ): IRendererModel {
    const { component, data } = toRender;
    const renderModel = {
      component,
      data: data ? {
        ...data, props: {
          index: index,
          key: key,
          row: row,
        }, [key]: cellData
      } : { [key]: cellData },
    };
    return renderModel;
  }
}
